import React from 'react'
import styled from 'styled-components'
import avatar from '../assets/avatar.png'

const Hero = () => {
  return (
    <StyledHero id="about">
        <div className="hero-container">
            <div className="text-container">
                    <h1>Hello, I'm Tuasegun</h1>
                    <p>
                    A front-end developer who loves to build attractive and responsive sites. Having an appreciation for APIS with a 200 response, I incorporate them into a lot of my projects as their results have a nicer finish.
                    In my spare time, I learn new technologies and glean more information on my craft, while also writing technical articles.
                    </p>
            </div>
            <div className="img-container">
                <img src={avatar} alt="" />
            </div>
        </div>
    </StyledHero>
  )
}

export default Hero

const StyledHero = styled.div`
    .hero-container{
        padding: 4.3125rem 7.625rem 13.75rem 7.5rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        @media(max-width: 1266px)and (min-width: 800px){
            padding:  4.3125rem 5% 13.75rem 5%;
        }
        @media (max-width: 799px) {
            flex-direction: column;
            padding:  4.3125rem 5% 13.75rem 5%;
            align-items: flex-start;
        }
        .text-container{
            width: 50%;
            h1{
                font-size: 4.5625rem;
                font-weight: 500;
                line-height: 5.125rem;
                text-transform: uppercase;
                font-family: 'Space Grotesk', sans-serif;
                max-width: 34.5rem;
                color: #333333;
                @media (max-width: 799px) {
                    font-size: 3.125rem;
                    line-height: 3.75rem;
                }
            }
            p{
                font-size: 1.875rem;
                line-height: 2.5575rem;
                font-family: 'Nunito', sans-serif;
                font-weight: 500;
                margin-top: 2.5rem;
                color: #333333;
                @media (max-width: 799px) {
                    font-size: 1.125rem;
                    line-height: 1.5rem;
                }
            }
            @media (max-width: 799px) {
                width: 100%;
            }
        }
        .img-container{
        max-width: 40%;
        height: 100%;
        aspect-ratio: calc(1/1);
            @media (max-width: 799px) {
                width: 100%;
                max-width: 100%;
            }
        
        img{
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }
    }
`